Array.prototype.at ??= function (i) {
  return this[i < 0 ? this.length + i : i];
};
